import React, { useEffect, useState, useRef, useCallback } from "react";

const CHANNEL_ID = "UCDWCeTKGu34VwsPMHWndBYw";
const MAX_RESULTS = 6;

const MOCK_VIDEOS = [
  { id: "Ea9GUgqgLfc", snippet: { title: "✨Dr. Upasana's DIY DarkSpot, Redness & Skin Whitening Remedy – Get Glowing Skin at Home!#shorts#yt", publishedAt: "2025-02-20T00:00:00Z", thumbnails: { high: { url: "https://i.ytimg.com/vi/Ea9GUgqgLfc/hqdefault.jpg" } } }, statistics: { viewCount: "8135681" } },
  { id: "5bBjq2680G0", snippet: { title: "Durefishan's Favorite DIY Home Remedies for Glowing & Whitening Skin!#durefishansaleem#short#diy", publishedAt: "2025-02-09T00:00:00Z", thumbnails: { high: { url: "https://i.ytimg.com/vi/5bBjq2680G0/hqdefault.jpg" } } }, statistics: { viewCount: "7489898" } },
  { id: "ube_GJWFjEg", snippet: { title: "Dr. Upasana's Fast Hair Growth Challenge – Easy DIY Homemade Remedy!#haircare#drupasana#shorts#yt", publishedAt: "2025-02-24T00:00:00Z", thumbnails: { high: { url: "https://i.ytimg.com/vi/ube_GJWFjEg/hqdefault.jpg" } } }, statistics: { viewCount: "5047663" } },
  { id: "BBMx8bh9HMg", snippet: { title: "Dr. Upasana's Effective Hair Growth Tips for Thick, Healthy Hair!#drupasana#haircare#shorts#ytshort", publishedAt: "2025-02-06T00:00:00Z", thumbnails: { high: { url: "https://i.ytimg.com/vi/BBMx8bh9HMg/hqdefault.jpg" } } }, statistics: { viewCount: "3744585" } },
  { id: "yUyo0W6wfj4", snippet: { title: "बालों को घना और लंबा बनाने के 100% असरदार घरेलू उपाय |Dr. Upasana's Hair Growth Remedy!#shorts#hair", publishedAt: "2025-05-11T00:00:00Z", thumbnails: { high: { url: "https://i.ytimg.com/vi/yUyo0W6wfj4/hqdefault.jpg" } } }, statistics: { viewCount: "6179991" } },
  { id: "xgmuJWUPlNE", snippet: { title: "Homemade Facial Hair Removal – Easy & Natural Tips!#shorts#ytshort#facial#skincare", publishedAt: "2025-02-17T00:00:00Z", thumbnails: { high: { url: "https://i.ytimg.com/vi/xgmuJWUPlNE/hqdefault.jpg" } } }, statistics: { viewCount: "2223496" } },
];

export default function VideosSection() {
  const [videos, setVideos] = useState([]);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isFallback, setIsFallback] = useState(false);

  const loadedIds = useRef(new Set());
  const API_KEY = process.env.REACT_APP_YT_API_KEY;

  const fetchVideos = useCallback(async (pageToken = "") => {
    setLoading(true);
    try {
      if (!API_KEY) throw new Error("Missing API key");

      const searchUrl = `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=viewCount&maxResults=${MAX_RESULTS}${pageToken ? `&pageToken=${pageToken}` : ""}`;
      const res = await fetch(searchUrl);
      if (!res.ok) throw new Error("YouTube API request failed");
      const data = await res.json();

      const newIds = (data.items || [])
        .map(item => item.id?.videoId)
        .filter(id => id && !loadedIds.current.has(id));

      newIds.forEach(id => loadedIds.current.add(id));
      if (newIds.length === 0) return;

      const statsUrl = `https://www.googleapis.com/youtube/v3/videos?key=${API_KEY}&id=${newIds.join(",")}&part=snippet,statistics`;
      const statsRes = await fetch(statsUrl);
      if (!statsRes.ok) throw new Error("YouTube Stats API failed");
      const statsData = await statsRes.json();

      setVideos(prev => [...prev, ...statsData.items]);
      setNextPageToken(data.nextPageToken || null);
      setError(null);
    } catch (err) {
      console.warn("Falling back to mock videos:", err.message);
      setVideos(MOCK_VIDEOS);
      setIsFallback(true);
      setError(null);
    } finally {
      setLoading(false);
    }
  }, [API_KEY]);

  useEffect(() => {
    loadedIds.current = new Set();
    fetchVideos();
  }, [fetchVideos]);

  const totalViews = videos
    .reduce((acc, v) => acc + (parseInt(v.statistics?.viewCount, 10) || 0), 0)
    .toLocaleString();

  return (
    // ✅ Premium warm background section
    <section id="videos" className="py-16 md:py-24 section-rose">
      <div className="max-w-6xl mx-auto px-4">

        {/* ✅ Premium heading with Playfair Display + gold accent */}
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-3xl sm:text-4xl font-bold mb-3" style={{ fontFamily: "'Playfair Display', serif", color: "#1a1a2e" }}>
            Most Viewed Videos
          </h3>
          <div className="divider-gold w-32 mx-auto mb-4" />
          <p className="text-sm text-gray-500">
            Total Views:{" "}
            <strong style={{ color: "#d4a853" }}>{totalViews}</strong>
          </p>
        </div>

        {/* ✅ Skeleton loading */}
        {loading && videos.length === 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="rounded-2xl overflow-hidden animate-pulse">
                <div className="bg-pink-100 h-48 w-full" />
                <div className="p-4 space-y-2 bg-white/70">
                  <div className="h-4 bg-pink-100 rounded w-3/4" />
                  <div className="h-3 bg-pink-50 rounded w-1/2" />
                  <div className="h-8 bg-pink-100 rounded w-1/3 mt-3" />
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ✅ Glassmorphism video cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video) => (
            <div key={video.id} className="card-glass rounded-2xl overflow-hidden">

              {/* Thumbnail with overlay */}
              <a
                href={`https://www.youtube.com/watch?v=${video.id}`}
                target="_blank"
                rel="noreferrer"
                className="block relative group"
              >
                <img
                  src={video.snippet.thumbnails.high.url}
                  alt={video.snippet.title}
                  className="w-full h-44 sm:h-48 object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                {/* ✅ Premium play overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6 ml-1" fill="#c2185b" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                  </div>
                </div>
              </a>

              <div className="p-4">
                <h4
                  className="font-semibold text-gray-900 overflow-hidden mb-2 leading-snug"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "0.95rem"
                  }}
                >
                  {video.snippet.title}
                </h4>

                {/* ✅ Gold view count */}
                <p className="text-xs font-semibold mb-0.5" style={{ color: "#d4a853" }}>
                  👁 {parseInt(video.statistics?.viewCount, 10).toLocaleString()} views
                </p>
                <p className="text-xs text-gray-400 mb-3">
                  {new Date(video.snippet.publishedAt).toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "numeric" })}
                </p>

                {/* ✅ Premium button */}
                <a
                  href={`https://www.youtube.com/watch?v=${video.id}`}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-premium inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold min-h-[44px]"
                >
                  ▶ Watch Now
                </a>
              </div>
            </div>
          ))}
        </div>

        {error && <div className="text-red-500 mt-4 text-center">{error}</div>}

        {loading && videos.length > 0 && (
          <div className="mt-8 text-center" style={{ color: "#d4a853" }}>Loading more…</div>
        )}

        {/* ✅ Premium Load More button */}
        {nextPageToken && !loading && !isFallback && (
          <div className="flex mt-10 justify-center">
            <button
              className="btn-gold px-8 py-3 rounded-xl text-base font-semibold min-h-[48px]"
              onClick={() => fetchVideos(nextPageToken)}
            >
              Load More Videos
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
